import {
  BothBorders,
  LeftBorder,
  RightBorder,
} from '../../../core/components/threshold-bar/ThresholdBar.js';
import type { XYChartAxisInternal } from '../../types/xy-chart-internals.js';
export function getBorderThreshold(
  left: XYChartAxisInternal | undefined,
  right: XYChartAxisInternal | undefined,
) {
  const leftBorder = !left || left.hidden ? BothBorders : LeftBorder;
  const rightBorder = !right || right?.hidden ? BothBorders : RightBorder;
  return { leftBorder, rightBorder };
}
